import { useState, useEffect } from 'react';
import { siteContent } from './content';
import { COLORS } from './utils/colors';
import { ComingSoon } from './components/ComingSoon';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Approach } from './components/Approach';
import { Engagement } from './components/Engagement';
import { Outcomes } from './components/Outcomes';
import { Stories } from './components/Stories';
import { NonProfit } from './components/NonProfit';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

const Rockmelon = () => {
  const [isVisible, setIsVisible] = useState({});
  const [activeSection, setActiveSection] = useState('hero');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!siteContent.isLive) return;

    const observer = new IntersectionObserver(
      (entries) => {
        let maxEntry = null;
        let maxRatio = 0;

        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
            maxRatio = entry.intersectionRatio;
            maxEntry = entry;
          }

          setIsVisible(prev => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting
          }));
        });

        if (maxEntry && maxRatio > 0.1) {
          setActiveSection(maxEntry.target.id);
        }
      },
      { 
        threshold: [0.1, 0.3, 0.5, 0.7], 
        rootMargin: '-80px 0px -40% 0px'
      }
    );

    document.querySelectorAll('[id]').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (sectionId) => {
    // Navbar clearance comes from `section { scroll-margin-top }` in index.css
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  if (!siteContent.isLive) return <ComingSoon />;

  return (
    <div className="min-h-screen overflow-hidden" style={{ backgroundColor: 'white', color: COLORS.navy, fontFamily: 'Inter, sans-serif' }}>
      <Navbar activeSection={activeSection} scrollToSection={scrollToSection} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Hero isVisible={isVisible.hero} scrollToSection={scrollToSection} />
      <About isVisible={isVisible.about} />
      <Approach isVisible={isVisible.approach} />
      <Engagement isVisible={isVisible.engagement} />
      <Outcomes isVisible={isVisible.outcomes} />
      <Stories isVisible={isVisible.stories} />
      <NonProfit isVisible={isVisible.nonprofit} />
      <Testimonials isVisible={isVisible.testimonials} />
      <Contact isVisible={isVisible.contact} />
      <Footer />
    </div>
  );
};

export default Rockmelon;
